module.exports = __webpack_public_path__ + "img/kia-ev-stock-img.39a7c81e.png";